export default "/images/71000011ddd213982d9af1e457f7fd63.avif";